import { Reveal, Eyebrow } from "../components/Reveal";

const STEPS = [
  {
    title: "Go Through the Portal.",
    text: "Visit trust.igcfirm.com and complete your intake at your own pace. The portal walks you through every step including your trust structure, asset protection setup, beneficiaries, and everything your family needs. Takes about 20 to 30 minutes. No pressure no rush.",
  },
  {
    title: "I Call You Personally.",
    text: "Before anything finalizes, before you pay a single dollar, I personally call you. We talk through every question you have. I answer everything. You move forward only when you are completely satisfied.",
  },
  {
    title: "Your Protection Is in Place.",
    text: "Once you are ready your completed trust is released to you. From that moment your home, your assets, your business, and everything you have built are legally protected. I personally walk you through your documents and what comes next. Your family's protection does not start someday. It starts the day your trust is finalized.",
  },
];

export const HowItWorks = () => (
  <section className="bg-parchment py-24 sm:py-36" data-testid="how-it-works-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <Eyebrow>How It Works</Eyebrow>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-ink tracking-tight leading-[1.06] mt-6">
          How It Works. <em className="text-goldeep italic">Simple as 1 2 3.</em>
        </h2>
      </Reveal>
      <div className="mt-16 sm:mt-24 space-y-0">
        {STEPS.map((s, i) => (
          <Reveal key={i} delay={0.08 * i}>
            <div className="group grid md:grid-cols-12 gap-4 md:gap-10 items-start border-t border-ink/12 py-10 sm:py-14 hover:bg-ink/[0.025] transition-colors duration-500 px-2 sm:px-4" data-testid={`step-card-${i + 1}`}>
              <div className="md:col-span-2">
                <span className="font-display text-6xl sm:text-8xl text-goldeep/25 leading-none group-hover:text-goldeep/60 transition-colors duration-500">
                  {i + 1}
                </span>
              </div>
              <div className="md:col-span-4">
                <h3 className="font-display text-2xl sm:text-3xl text-ink leading-snug">Step {i + 1}. {s.title}</h3>
              </div>
              <div className="md:col-span-6">
                <p className="text-ink/70 leading-relaxed text-base sm:text-lg">{s.text}</p>
              </div>
            </div>
          </Reveal>
        ))}
        <div className="border-t border-ink/12" />
      </div>
    </div>
  </section>
);
